export class User {
  public username: string; // 用户名;统一社会信用代码，作为登录账号
  public password: string; // 密码
  public name: string; // 真实姓名
  public email: string; // 邮箱
  public company: string; // 公司名称
  public position: string; // 职位
  public industry: string; // 行业
  public phoneNo: string; // 电话
  public imageUrlPath: any; // 头像路径
  public companyId: string; // 公司ID
  public companyName: string; // 公司名称
  public status: string; // 状态:0：认证通过，-1：认证中，-2：删除
  public legalPerson: string; // 法定代表人
  public establishmentDate: string; // 成立日期
  public address: string; // 地址
  public faxNo: string; // 传真号码
  public website: string; // 公司网址
  public logoUrlPath: any; // 公司logo地址
  public userId: string; // 用户ID
  public id: string; // id
  public oldPwd: string; // 旧密码
  public userType: string; // 用户类型
  public backContent :string;//反馈内容
  public download:string; //免费下载次数
  public downloadDate: Date;//免费下载报告有效期
  public email1: string; // 邮箱
  public hasModifyUsername = "0"; // 是否已修改用户名，0：未修改，1：已修改

  constructor() {
  }


}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/models/user.ts